import { SparklesIcon } from "@heroicons/react/24/outline";
import { useLocation, useNavigate } from "react-router-dom";

import { Button, Headline, Small } from "@fronterahealth/frontera-ui-components";

import { getOrderedAssessmentReportSubRoutes } from "@pages/AssessmentReportV2Details/helpers";
import { InitialAssessmentPageRoute } from "@pages/AssessmentReportV2Details/types";

interface ReportNotReadyYetProps {
  item: "Prioritization" | "Short Term Goals" | "Report Part 2" | "Report Part 1" | "Review";
}

const useGetPreviousRoute = () => {
  const { pathname } = useLocation();
  const currentRoute =
    (pathname.split("#")?.pop()?.split("/").pop() as InitialAssessmentPageRoute) ||
    ("upload-files" as InitialAssessmentPageRoute);
  const { getPastRoute } = getOrderedAssessmentReportSubRoutes();

  const pastRoute = getPastRoute(currentRoute);
  return pastRoute;
};

export const ReportNotReadyYet: React.FC<ReportNotReadyYetProps> = ({ item }) => {
  const go = useNavigate();
  const pastRoute = useGetPreviousRoute();
  return (
    <div className="mt-10 flex flex-col items-center justify-center gap-y-4">
      <SparklesIcon className="h-12 w-12 text-limestone-200" /> <Headline size="medium">{item} Not Ready Yet</Headline>
      <Small>
        This step of the report is not ready to be worked on yet. You must fill out and submit the previous steps of the
        report before filling out this one.
      </Small>
      <div className="flex items-center">
        {pastRoute ? (
          <Button
            appearance="link"
            text="Go to previous step"
            onClick={() => {
              go(`../${pastRoute}`);
            }}
          />
        ) : null}
        <Button
          appearance="primary"
          text="Return to Assessments"
          onClick={() => {
            go("/assessment-reports");
          }}
        />
      </div>
    </div>
  );
};
